export const All_LIST_QUESTION = 'All_LIST_QUESTION';

export const All_LIST_QUESTION_CLEAR = 'All_LIST_QUESTION_CLEAR';
